import api from '@/lib/api';

const POLL_MS = 2000;
const TIMEOUT_MS = 12 * 60 * 1000;

export async function pollPublishVideoAutofill(jobId, { onProgress, isCurrent } = {}) {
  const started = Date.now();
  while (Date.now() - started < TIMEOUT_MS) {
    if (isCurrent && !isCurrent()) {
      const cancelled = new Error('cancelled');
      cancelled.cancelled = true;
      throw cancelled;
    }
    const { data } = await api.get(`/social-publish/youtube/autofill-from-video/${jobId}`);
    if (onProgress) onProgress(data);
    const status = String(data?.status || '').toLowerCase();
    if (status === 'completed') return data.result || {};
    if (status === 'failed' || status === 'cancelled') {
      const err = new Error(data.error || data.message || 'Autofill failed');
      err.response = { data: { detail: data.error || data.message || 'Autofill failed' } };
      throw err;
    }
    await new Promise((resolve) => setTimeout(resolve, POLL_MS));
  }
  const err = new Error('Autofill timed out while transcribing the video');
  err.response = { data: { detail: err.message } };
  throw err;
}

export async function autofillFromUploadedVideo(body, options) {
  const { data } = await api.post('/social-publish/youtube/autofill-from-video', body);
  return pollPublishVideoAutofill(data.job_id, options);
}

export function watchDiscoverySeo(videoUrl, { isCurrent, onPack, timeoutMs = 90000 } = {}) {
  const started = Date.now();
  const timer = setInterval(async () => {
    if (Date.now() - started > timeoutMs || (isCurrent && !isCurrent())) {
      clearInterval(timer);
      return;
    }
    try {
      const { data } = await api.get('/channel/competitors/analyses', { params: { video_url: videoUrl } });
      const row = (data?.items || [])[0];
      if (!row || data?.locked) {
        if (data?.locked) clearInterval(timer);
        return;
      }
      if (row.status === 'failed') {
        clearInterval(timer);
        return;
      }
      if (row.status === 'ready' && row.pack?.seo_pack) {
        clearInterval(timer);
        if (onPack) onPack(row.pack.seo_pack);
      }
    } catch {
      clearInterval(timer);
    }
  }, POLL_MS);
  return () => clearInterval(timer);
}
